import {
  HomeIcon,
  CalendarDaysIcon,
  BookOpenIcon,
  FolderOpenIcon,
  DocumentTextIcon,
  ChartBarIcon,
  DocumentChartBarIcon,
  CurrencyDollarIcon,
  TableCellsIcon,
  ServerStackIcon,
  DocumentIcon,
  CalculatorIcon,
  BanknotesIcon,
  RectangleStackIcon,
  MicrophoneIcon,
  AcademicCapIcon,
  TrophyIcon,
  QuestionMarkCircleIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Home",
    href: "/hub",
    icon: HomeIcon,
    current: false,
    internalName: "home",
  },
  {
    name: "Event Directory",
    href: "/event-registration/events",
    icon: CalendarDaysIcon, // Changed from BookOpenIcon to CalendarDaysIcon
    current: false,
    internalName: "event-directory",
    roles: ["ROLE_SUPER_ADMIN"],
  },
  {
    name: "Resource Library",
    href: "/hub/resources",
    icon: BookOpenIcon, // Kept BookOpenIcon - perfect for resources
    current: false,
    internalName: "resource_library",
  },
  {
    name: "News",
    href: "/hub/news",
    icon: DocumentTextIcon,
    current: false,
    internalName: "news",
  },
  {
    name: "Podcasts",
    href: "/hub/podcasts",
    icon: MicrophoneIcon,
    current: false,
    internalName: "podcasts",
  },
  {
    name: "Document Library",
    href: "/hub/document-library",
    icon: FolderOpenIcon, // Changed from DocumentIcon to FolderOpenIcon
    current: false,
    internalName: "document_library",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_COACH"],
    children: [
      {
        name: "Monthly Balance Sheet",
        href: "/hub/document-library/monthly-balance-sheet",
        icon: ChartBarIcon, // Changed from DocumentIcon to ChartBarIcon
        current: false,
        internalName: "monthly_balance_sheet",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_COACH"],
      },
      {
        name: "Profit and Loss",
        href: "/hub/document-library/profit-and-loss",
        icon: CurrencyDollarIcon, // Changed from DocumentIcon to CurrencyDollarIcon
        current: false,
        internalName: "profit_and_loss",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_COACH"],
      },
      {
        name: "Transaction List",
        href: "/hub/document-library/transaction-list",
        icon: TableCellsIcon, // Changed from DocumentIcon to TableCellsIcon
        current: false,
        internalName: "transaction_list",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_COACH"],
      },
    ],
  },
  {
    name: "Data Connector",
    href: "/hub/data-connector",
    icon: ServerStackIcon, // Changed from CircleStackIcon to ServerStackIcon
    current: false,
    internalName: "data_connector",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_COACH"],
  },
  {
    name: "Training",
    href: process.env.REACT_APP_MEMBER_PORTAL_URL || "",
    icon: AcademicCapIcon,
    current: false,
    internalName: "training",
  },
  {
    name: "Scoreboard",
    href: process.env.REACT_APP_SCOREBOARD_URL || "",
    icon: TrophyIcon,
    current: false,
    internalName: "scoreboard",
  },
  {
    name: "Partner Network",
    href: process.env.REACT_APP_PARTNER_NETWORK_URL || "",
    icon: UsersIcon,
    current: false,
    internalName: "partner-network",
  },
  {
    name: "Help",
    href: `${process.env.REACT_APP_CRAFT_CMS_URL}/help-topics`,
    icon: QuestionMarkCircleIcon,
    current: false,
    internalName: "help",
  },
];

const hubConfig = {
  sectionName: "hub",
  defaultRoute: "/hub",
  navigation,
};

export default hubConfig;
